module.exports = __webpack_public_path__ + "static/media/Icon material-location-on.7a65d78d.svg";